import React from 'react'
import './PortalLoginGateway.css'

export default function PortalLoginGateway({ portalType = 'staff', workspaceLabel, clubCode, clubName, clubLogoUrl, loginImageUrl, onSignIn }) {
  const defaultSubtitle = portalType === 'member' ? 'Member Portal' : 'Staff Workspace'
  const portalLabel = workspaceLabel || (portalType === 'member' ? 'MEMBER PORTAL' : 'STAFF WORKSPACE')
  const subtitle = workspaceLabel ? portalLabel.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : defaultSubtitle
  const fallbackName = clubName || (clubCode ? `Club ${clubCode}` : 'Your Club')
  const hasImage = Boolean(loginImageUrl)
  const hasLogo = Boolean(clubLogoUrl)
  const bgStyle = hasImage
    ? { backgroundImage: `linear-gradient(120deg, rgba(8,20,38,.78), rgba(238,232,221,.50)), url("${loginImageUrl}")` }
    : { background: 'radial-gradient(circle at 20% 20%, #efe5d2 0, transparent 32%), linear-gradient(135deg, #07162d 0%, #40506a 52%, #d9ccb6 100%)' }

  return (
    <main className="portal-login-gateway" style={bgStyle} data-testid="portal-login-gateway">
      <div className="portal-login-gateway__veil" />
      <section className="portal-login-gateway__card" aria-label={`${subtitle} sign in`}>
        <div className="portal-login-gateway__panel">
          <div className="portal-login-gateway__panel-inner">
            <p className="portal-login-gateway__brand">{portalLabel}</p>
            <div className="portal-login-gateway__identity">
              {hasLogo ? (
                <div className="portal-login-gateway__logo-stage" data-testid="portal-login-gateway-logo-stage">
                  <img
                    className="portal-login-gateway__logo"
                    src={clubLogoUrl}
                    alt={`${fallbackName} logo`}
                    loading="eager"
                    decoding="async"
                  />
                </div>
              ) : null}
              <h1>{fallbackName}</h1>
            </div>
            <div className="portal-login-gateway__action">
              <p className="portal-login-gateway__eyebrow">Welcome Back</p>
              <button type="button" className="portal-login-gateway__button" onClick={onSignIn}>
                Sign in securely
              </button>
            </div>
          </div>
        </div>
        <div className={`portal-login-gateway__media${hasImage ? '' : ' portal-login-gateway__media--fallback'}`}>
          {hasImage ? <img src={loginImageUrl} alt={`${fallbackName} portal`} /> : <div className="portal-login-gateway__monogram">P</div>}
        </div>
      </section>
    </main>
  )
}
